export default {"src":"/_next/static/image/public/images/mounjaro_consult.b670af786cbfce0bb79c7fdfa2ae7967.svg","height":51,"width":51};